import ReactGA from 'react-ga4';

export const initGA = () => {
    const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID; // ex: G-XXXXXXX
    if (!gaId) return false;

    ReactGA.initialize(gaId);
    return true;
};

export const logPageView = (path?: string) => {
    ReactGA.send({ hitType: 'pageview', page: path ?? window.location.pathname });
};
